import styled from "styled-components";

// Detail Modal Styles
export const DetailModalContainer = styled.div`
    padding: 8px 0;
`;

export const DetailTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
`;
